import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=9777e1d2"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=9777e1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports